import React, {useState} from 'react';

import {AppButton} from '@/components/Button';
import {RegularCleaningIcon} from '@/components/Icons';
import {StickyHeader} from '@/components/Layout';
import appConfig from '@/config/appConfig.typed';
import * as advanceDiagnosticScreenTypes from '@/consts/advanceDiagnostic/advanceDiagnosticScreenTypes';
import {DEVICE_TYPES} from '@/consts/device/deviceTypes';
import {AD_FITTING_CONSUMABLES_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import {getAriaLabel} from '@/services/accessibilityService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import appRouterService from '@/services/route/appRouterService';
import routerService from '@/services/route/routerService';

import advanceDiagnosticService from '../advanceDiagnosticService';
import AdvancedDiagnosticLayout from '../components/AdvancedDiagnosticLayout';

const AdvancedDiagnosticFittingConsumables = () => {
    const isMobile = useIsMobileLayout();
    const localizedStrings = getLocalizedStrings();
    const diagnosticData = appConfig.getAdConfig(DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER, 'step3');
    const dataArrayCount = diagnosticData.length;
    const [dataIndex, setDataIndex] = useState(0);
    const isLastStep = dataArrayCount - 1 === dataIndex;
    const {
        title,
        description,
        acceptButtonText,
        acceptButtonAriaLabelKey,
        declineButtonText,
        declineButtonAriaLabelKey,
        errorCode,
        isHolder,
    } = diagnosticData[dataIndex] || {};

    const onBackButtonClick = () => {
        if (dataIndex > 0) {
            setDataIndex(dataIndex - 1);
        } else {
            routerService.goBack();
        }
    };

    const declineClick = () => {
        const screenName = advanceDiagnosticScreenTypes.QUESTIONNAIRE_MARKET_SCREEN;

        advanceDiagnosticService.setInferenceCodeAndRedirect(errorCode, isHolder, screenName, true);
    };

    const onNextClick = () => {
        if (isLastStep) {
            appRouterService.forwardToFittingConsumablesResolvedAD();
        } else {
            setDataIndex(dataIndex + 1);
        }
    };

    useDocumentTitle(localizedStrings[AD_FITTING_CONSUMABLES_HEADER_TITLE]);

    return (
        <AdvancedDiagnosticLayout>
            <AdvancedDiagnosticLayout.ContentWrapper>
                <AdvancedDiagnosticLayout.Container
                    sectionClassName='justify-between ml:justify-center'
                    onBackButtonClick={isMobile && onBackButtonClick}
                >
                    {isMobile && (
                        <StickyHeader
                            onBack={onBackButtonClick}
                            title={localizedStrings[AD_FITTING_CONSUMABLES_HEADER_TITLE]}
                        />
                    )}

                    <div className='flex flex-col items-center text-center'>
                        <RegularCleaningIcon className='h-16 w-16' />
                        <h1 className='mt-4 text-28 ml:mb-4'>{localizedStrings[title]}</h1>
                        <p>
                            <span className='whitespace-pre-line'>{localizedStrings[description]}</span>
                        </p>
                    </div>
                    <div className='mt-10 w-full md:w-auto ml:mt-8 ml:w-full'>
                        <AppButton
                            primary
                            light
                            className='mb-3 mt-0 md:min-w-[346px] ml:w-full'
                            onClick={onNextClick}
                            aria-label={getAriaLabel(acceptButtonAriaLabelKey)}
                        >
                            {localizedStrings[acceptButtonText]}
                        </AppButton>
                        <AppButton
                            secondary
                            light
                            className='mb-3 mt-0 md:min-w-[346px] ml:w-full'
                            onClick={declineClick}
                            aria-label={getAriaLabel(declineButtonAriaLabelKey)}
                        >
                            {localizedStrings[declineButtonText]}
                        </AppButton>
                    </div>
                </AdvancedDiagnosticLayout.Container>
            </AdvancedDiagnosticLayout.ContentWrapper>
        </AdvancedDiagnosticLayout>
    );
};

export default AdvancedDiagnosticFittingConsumables;
